import FormPropertiesEditor from './FormPropertiesEditor';
import hook from './useFormProperties';

export const useFormProperties = hook;
export default FormPropertiesEditor;
